<template>
  <div>
    <BaseModal class="upload-modal" v-model="isOpenModal">
      <div class="file-uploader">
        <template v-if="!processingFile && !response && !polling">
          <h2>Select Report</h2>
          <div class="body">
            <div>
              <div>
                <br />
                <div v-html="description" />
              </div>
              <select
                class="default-select full bordered"
                name="file_type"
                id="file_selector"
                v-model="formValues.fileType"
                @change="LoadOtherOptions()"
              >
                <option value="">Select the type of file</option>
                <option
                  v-for="option in reportsOptions"
                  :value="option.value"
                  :key="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
              <div
                v-if="otherFormOptions && formValues.otherOptions"
                class="other-inputs"
              >
                <div
                  class="input"
                  v-for="field in otherFormOptions"
                  :key="field.inputId"
                >
                  <DynamicFormField
                    :data="field"
                    v-model="formValues.otherOptions[field.inputId]"
                    @input="handleFieldChange(field.inputId, $event)"
                  />
                </div>
              </div>
              <button
                v-if="formValues.fileType"
                id="upload-btn"
                class="btn-dark-button my-6 w-40"
                @click="requestReport()"
              >
                Request Report
              </button>
              <div class="footer">
                * Category pending to be implemented.
              </div>
            </div>
          </div>
        </template>
        <template v-if="polling">
          <h2>Generating Report</h2>
          <div class="body responses flex flex-col items-center">
            <BaseSmallSpinner />
            <p class="mt-4 text-gray-600">
              Processing... {{ pollSeconds }}s elapsed
            </p>
            <button
              class="btn-error-button w-40 mx-auto mt-6"
              @click="cancelPolling()"
            >
              Close
            </button>
          </div>
        </template>
        <template v-if="response">
          <h2>Result</h2>
          <div class="body responses flex flex-col">
            <table>
              <tr>
                <td>
                  File name:
                </td>
                <td>
                  {{ response.fileName }}
                </td>
              </tr>
              <tr>
                <td>
                  Status
                </td>
                <td>
                  {{ response.reportStatus }}
                </td>
              </tr>
              <tr>
                <td>Result</td>
                <td>{{ response.result.message }}</td>
              </tr>
            </table>

            <div class="flex flex-row">
              <button
                class="btn-error-button w-40 mx-auto mt-6"
                @click="resetResponse()"
              >
                Reset
              </button>
              <button
                v-if="response.s3Path && response.s3Route"
                class="btn-dark-button w-40 mx-auto mt-6"
                @click="downloadFile(response.s3Path, response.s3Route)"
              >
                download
              </button>
            </div>
          </div>
        </template>
        <div v-if="processingFile">
          <BaseSmallSpinner />
        </div>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import {
  requestReport as requestReportToStore,
  getReportFileInfo,
  getReportsOptions,
  signAndDownloadFile
} from "@/api/store/ReportGeneratorService.js";
import {
  getVehicleBrands,
  getBrands,
  getDependencyOptions,
  getPriceGroups
} from "@/api/store/ProductsService.js";
import {
  getCategories,
  getSubcategories
} from "@/api/store/CategoriesService.js";
import { getWarehouses } from "@/api/store/WarehouseService.js";
import { mapGetters } from "vuex";
import DynamicFormField from "@/components/shared/dynamicForm/DynamicFormField.vue";
export default {
  components: {
    DynamicFormField
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    forceType: {
      type: [String, Boolean],
      required: false,
      default: false
    }
  },
  data() {
    return {
      isOpenModal: this.value,
      reportsOptions: [],
      processingFile: false,
      formValues: {
        fileType: "",
        otherOptions: {}
      },
      otherFormOptions: null,
      response: null,
      polling: false,
      pollSeconds: 0,
      pollTimer: null,
      pollReportId: null
    };
  },
  computed: {
    ...mapGetters("general", ["getDepartments"]),
    isOpen() {
      return this.value;
    },
    formValuesValid() {
      if (this.formValues.fileType != "") {
        return {
          valid: true,
          message: ""
        };
      } else {
        return {
          valid: false,
          message: "Type of file no selected"
        };
      }
    },
    description() {
      if (this.formValues?.fileType) {
        let desc = this.reportsOptions.find(
          x => x.value == this.formValues.fileType
        );
        desc = desc.description || "";
        return desc;
      } else {
        return "";
      }
    }
  },
  watch: {
    isOpenModal(val) {
      this.$emit("input", val);
      this.step = 0;
    },
    value(val) {
      this.resetResponse();
      this.isOpenModal = val;
      this.step = 0;
    },
    formValues: {
      deep: true,
      handler() {
        this.fileUploadResponse = [];
      }
    }
  },
  mounted() {
    this.reportsOptions = getReportsOptions();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    resetResponse() {
      this.response = null;
      this.polling = false;
      this.pollSeconds = 0;
      this.pollReportId = null;
      this.stopPolling();
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    cancelPolling() {
      this.stopPolling();
      this.polling = false;
      this.pollSeconds = 0;
      this.isOpenModal = false;
    },
    startPolling(reportId) {
      this.pollSeconds = 0;
      this.pollTimer = setInterval(async () => {
        this.pollSeconds += 3;
        try {
          const info = await getReportFileInfo(reportId);
          if (info.status !== "in_process") {
            this.stopPolling();
            this.polling = false;
            this.response = {
              reportId: info.id,
              fileName: info.fileName,
              reportStatus: info.status,
              s3Path: info.s3Path,
              s3Route: info.s3Url,
              result: info.results
            };
            const succeeded = info.status === "created";
            this.$toast.open({
              message: succeeded
                ? "Report generated"
                : "Report generation failed",
              type: succeeded ? "success" : "error",
              position: "top-right"
            });
            this.$emit("reportGenerationFinished");
          }
        } catch (e) {
          // transient error — keep polling
        }
      }, 3000);
    },
    handleFieldChange(fieldId, value) {
      console.log(`Field ${fieldId} changed to:`, value, typeof value);

      // Handle department changes specifically
      if (
        fieldId === "department" &&
        this.formValues.fileType === "products_by_category"
      ) {
        console.log("Department field changed, updating warehouse options");
        if (value && value !== "") {
          this.updateWarehouseOptions(value);
        } else {
          // Clear warehouse options when no department is selected
          this.clearWarehouseOptions();
        }
      }

      // Handle category changes to load subcategories
      if (fieldId === "category") {
        if (value && (Array.isArray(value) ? value.length > 0 : value !== "")) {
          this.updateSubcategoryOptions(value);
        } else {
          this.clearSubcategoryOptions();
        }
      }

      // Handle category_url changes to load sub_category_url options
      if (fieldId === "category_url") {
        if (value && (Array.isArray(value) ? value.length > 0 : value !== "")) {
          this.updateSubCategoryUrlOptions(value);
        } else {
          this.clearSubCategoryUrlOptions();
        }
      }
    },
    clearSubCategoryUrlOptions() {
      const idx = this.otherFormOptions?.findIndex(
        x => x.inputId === "sub_category_url"
      );
      if (idx >= 0) {
        this.$set(this.otherFormOptions[idx], "options", []);
        this.$set(this.formValues.otherOptions, "sub_category_url", []);
      }
    },
    async updateSubCategoryUrlOptions(selectedUrls) {
      const urls = Array.isArray(selectedUrls) ? selectedUrls : [selectedUrls];
      const categoryUrlIndex = this.otherFormOptions?.findIndex(
        x => x.inputId === "category_url"
      );
      const subCategoryUrlIndex = this.otherFormOptions?.findIndex(
        x => x.inputId === "sub_category_url"
      );
      if (categoryUrlIndex < 0 || subCategoryUrlIndex < 0) return;

      const categoryOptions =
        this.otherFormOptions[categoryUrlIndex].options || [];
      const previouslySelected =
        this.formValues.otherOptions.sub_category_url || [];
      const currentOptions =
        this.otherFormOptions[subCategoryUrlIndex].options || [];

      const selectedLabelsMap = {};
      previouslySelected.forEach(val => {
        const found = currentOptions.find(opt => opt.value === val);
        if (found) selectedLabelsMap[val] = found.label;
      });

      let allSubcategories = previouslySelected.map(val => ({
        value: val,
        label: selectedLabelsMap[val] || val
      }));

      for (const url of urls) {
        const categoryOption = categoryOptions.find(c => c.value === url);
        if (!categoryOption?.id) continue;
        try {
          const res = await getSubcategories(categoryOption.id);
          const subcategories = res?.subcategories || res;
          if (Array.isArray(subcategories)) {
            subcategories.forEach(s => {
              if (
                !allSubcategories.find(sub => sub.value === s.subCategoryUrl)
              ) {
                allSubcategories.push({
                  label: s.subCategoryName,
                  value: s.subCategoryUrl
                });
              }
            });
          }
        } catch (err) {
          console.error(`Error loading subcategories for ${url}:`, err);
        }
      }

      this.$set(
        this.otherFormOptions[subCategoryUrlIndex],
        "options",
        allSubcategories
      );
      this.$set(
        this.formValues.otherOptions,
        "sub_category_url",
        previouslySelected.filter(val =>
          allSubcategories.find(sub => sub.value === val)
        )
      );
    },
    clearSubcategoryOptions() {
      const subcategoryIndex = this.otherFormOptions?.findIndex(
        x => x.inputId == "subcategory"
      );
      if (subcategoryIndex >= 0) {
        this.$set(this.otherFormOptions[subcategoryIndex], "options", []);
        this.$set(this.formValues.otherOptions, "subcategory", []);
      }
    },
    async updateSubcategoryOptions(categoryValue) {
      // Handle both single and multiple categories
      const categories = Array.isArray(categoryValue)
        ? categoryValue
        : [categoryValue];

      try {
        const subcategoryIndex = this.otherFormOptions?.findIndex(
          x => x.inputId == "subcategory"
        );

        if (subcategoryIndex < 0) return;

        // Keep previously selected subcategories
        const previouslySelected =
          this.formValues.otherOptions.subcategory || [];
        const currentOptions =
          this.otherFormOptions[subcategoryIndex].options || [];

        // Create a map of selected ID -> label to preserve labels
        const selectedLabelsMap = {};
        previouslySelected.forEach(selectedId => {
          const found = currentOptions.find(opt => opt.value === selectedId);
          if (found) {
            selectedLabelsMap[selectedId] = found.label;
          }
        });

        // Start with options for previously selected items (maintain their labels)
        let allSubcategories = previouslySelected.map(id => ({
          value: id,
          label: selectedLabelsMap[id] || id
        }));

        // Fetch subcategories for each selected category
        for (const categoryId of categories) {
          if (categoryId) {
            try {
              const subcategories = await getSubcategories(categoryId);
              if (Array.isArray(subcategories)) {
                subcategories.forEach(s => {
                  // Check if this subcategory is already in the list
                  if (!allSubcategories.find(sub => sub.value === s.id)) {
                    allSubcategories.push({
                      label: s.subCategoryName,
                      value: s.id
                    });
                  }
                });
              }
            } catch (error) {
              console.error(
                `Error loading subcategories for category ${categoryId}:`,
                error
              );
            }
          }
        }

        this.$set(
          this.otherFormOptions[subcategoryIndex],
          "options",
          allSubcategories
        );

        // Keep all previously selected subcategories - don't filter them out
        this.$set(
          this.formValues.otherOptions,
          "subcategory",
          previouslySelected
        );
      } catch (error) {
        console.error("Error loading subcategories:", error);
        this.$toast.open({
          message: "Error loading subcategories",
          type: "error",
          position: "top-right"
        });
      }
    },
    clearWarehouseOptions() {
      const warehousesOptionsIndex = this.otherFormOptions?.findIndex(
        x => x.inputId == "warehouse"
      );
      if (warehousesOptionsIndex >= 0) {
        this.$set(this.otherFormOptions[warehousesOptionsIndex], "options", []);
        this.$set(this.formValues.otherOptions, "warehouse", "");
      }
    },
    updateWarehouseOptions(departmentId = null) {
      const departmentToUse =
        departmentId || this.formValues.otherOptions.department;

      if (
        this.formValues.fileType === "products_by_category" &&
        departmentToUse
      ) {
        console.log(
          "Updating warehouse options for department:",
          departmentToUse
        );
        const departments = this.getDepartments;
        const foundDepartment = departments.find(
          x => x.full.departamentoId == departmentToUse
        );

        console.log("Found department:", foundDepartment);

        if (foundDepartment && this.otherFormOptions) {
          // Reset warehouse selection
          this.$set(this.formValues.otherOptions, "warehouse", "");

          const warehousesOptionsIndex = this.otherFormOptions.findIndex(
            x => x.inputId == "warehouse"
          );
          if (warehousesOptionsIndex >= 0) {
            console.log(
              "Setting warehouse options:",
              foundDepartment.full.depositos
            );
            this.$set(
              this.otherFormOptions[warehousesOptionsIndex],
              "options",
              foundDepartment.full.depositos.map(d => {
                return {
                  label: d.descDeposito,
                  value: d.depositoId
                };
              })
            );
          }
        }
      }
    },
    async downloadFile(s3Path, s3Url) {
      console.log("s3Path", s3Path, s3Url);
      const res = await signAndDownloadFile(s3Path, s3Url);
      console.log("res", res);
      if (!res) {
        this.$toast.open({
          message: `Error Downloading file`,
          type: "error",
          position: "top-right"
        });
      }
      return;
    },
    requestReport() {
      this.resetResponse();
      this.processingFile = true;

      // Create a copy of form values and remove fields marked with serverField: false
      const formValuesToSend = JSON.parse(JSON.stringify(this.formValues));
      if (this.otherFormOptions) {
        this.otherFormOptions.forEach(field => {
          if (field.serverField === false && formValuesToSend.otherOptions) {
            delete formValuesToSend.otherOptions[field.inputId];
          }
        });
      }

      requestReportToStore(formValuesToSend)
        .then(res => {
          if (res.reportId && res.status === "in_process") {
            // Server returned immediately — start polling for completion
            this.pollReportId = res.reportId;
            this.polling = true;
            this.startPolling(res.reportId);
          } else {
            // Fallback: server returned the full result synchronously
            this.response = res;
            this.$toast.open({
              message: "Report generated",
              type: "success",
              position: "top-right"
            });
            this.$emit("reportGenerationFinished");
          }
        })
        .catch(() => {
          this.$toast.open({
            message: "Error generating report",
            type: "error",
            position: "top-right"
          });
          this.$emit("reportGenerationFinished");
        })
        .finally(() => {
          this.processingFile = false;
        });
    },
    async LoadOtherOptions() {
      this.formValues.otherOptions = {};
      this.otherFormOptions = null;
      const otherOptionsSet = this.reportsOptions.find(
        x => x.value == this.formValues.fileType
      );
      if (otherOptionsSet?.otherOptions) {
        this.otherFormOptions = otherOptionsSet.otherOptions;
        otherOptionsSet.otherOptions.forEach(t => {
          // Initialize multiselect fields as arrays, others as empty strings
          const initialValue = t.inputType === "multiselect" ? [] : "";
          this.$set(this.formValues.otherOptions, t.inputId, initialValue);
        });
      }
      switch (this.formValues.fileType) {
        case "products_by_category": {
          const departments = this.getDepartments;
          const index = otherOptionsSet.otherOptions.findIndex(
            x => x.inputId == "department"
          );
          if (index >= 0) {
            otherOptionsSet.otherOptions[index].options = departments.map(d => {
              return {
                label: d.name,
                value: d.full.departamentoId
              };
            });
          }
          break;
        }
        case "no_picture_products": {
          const warehouseIndex = otherOptionsSet.otherOptions.findIndex(
            x => x.inputId == "warehouse"
          );
          if (warehouseIndex >= 0) {
            const warehouses = await getWarehouses();
            this.$set(otherOptionsSet.otherOptions[warehouseIndex], "options", [
              { label: "All", value: "all" },
              ...warehouses.map(w => ({
                label: w.descDeposito,
                value: w.depositoId
              }))
            ]);
            this.$set(this.formValues.otherOptions, "warehouse", "all");
          }
          break;
        }
      }

      // Load dynamic options based on field presence (works for any report type)
      try {
        // Check if report has brand field (skip if options are already hardcoded)
        const brandIndex = otherOptionsSet?.otherOptions?.findIndex(
          x => x.inputId === "brand"
        );
        if (
          brandIndex >= 0 &&
          !otherOptionsSet.otherOptions[brandIndex].options
        ) {
          const brandsData = await getBrands();
          if (brandsData && Array.isArray(brandsData)) {
            const brandOptions = brandsData.map(b => {
              return {
                label: b.name_show || b.nameShow || b.name,
                value: b.name
              };
            });
            this.$set(
              otherOptionsSet.otherOptions[brandIndex],
              "options",
              brandOptions
            );
          }
        }

        // Check if report has vehicle_brand field (skip if options are already hardcoded)
        const vehicleBrandIndex = otherOptionsSet?.otherOptions?.findIndex(
          x => x.inputId === "vehicle_brand"
        );
        if (
          vehicleBrandIndex >= 0 &&
          !otherOptionsSet.otherOptions[vehicleBrandIndex].options
        ) {
          const vehicleBrands = await getVehicleBrands();
          if (vehicleBrands && Array.isArray(vehicleBrands)) {
            const vehicleBrandOptions = vehicleBrands
              .filter(b => b.make !== null && b.make !== undefined)
              .map(b => {
                return {
                  label: b.make,
                  value: b.make
                };
              });
            this.$set(
              otherOptionsSet.otherOptions[vehicleBrandIndex],
              "options",
              vehicleBrandOptions
            );
          }
        }

        // Check if report has category field
        const categoryIndex = otherOptionsSet?.otherOptions?.findIndex(
          x => x.inputId === "category"
        );
        if (
          categoryIndex >= 0 &&
          !otherOptionsSet.otherOptions[categoryIndex].options
        ) {
          const categories = await getCategories();
          if (categories && Array.isArray(categories)) {
            this.$set(otherOptionsSet.otherOptions[categoryIndex], "options", [
              { label: "All", value: "" },
              ...categories.map(c => ({
                label: c.categoryName,
                value: c.id
              }))
            ]);
          }
        }

        // Initialize/populate subcategory options
        const subcategoryIndex = otherOptionsSet?.otherOptions?.findIndex(
          x => x.inputId === "subcategory"
        );
        if (
          subcategoryIndex >= 0 &&
          !otherOptionsSet.otherOptions[subcategoryIndex].options
        ) {
          // Initialize as empty, will be populated when category is selected
          this.$set(
            otherOptionsSet.otherOptions[subcategoryIndex],
            "options",
            []
          );
        }

        // Check if report has dependencia field
        const dependenciaIndex = otherOptionsSet?.otherOptions?.findIndex(
          x => x.inputId === "dependencia"
        );
        if (
          dependenciaIndex >= 0 &&
          !otherOptionsSet.otherOptions[dependenciaIndex].options
        ) {
          const dependencies = await getDependencyOptions();
          if (dependencies && Array.isArray(dependencies)) {
            this.$set(
              otherOptionsSet.otherOptions[dependenciaIndex],
              "options",
              dependencies
            );
          }
        }

        // Check if report has product_price_group field
        const priceGroupIndex = otherOptionsSet?.otherOptions?.findIndex(
          x => x.inputId === "product_price_group"
        );
        if (
          priceGroupIndex >= 0 &&
          !otherOptionsSet.otherOptions[priceGroupIndex].options
        ) {
          const priceGroups = await getPriceGroups();
          if (priceGroups && Array.isArray(priceGroups)) {
            const priceGroupOptions = priceGroups.map(pg => ({
              label: pg.value,
              value: pg.label
            }));
            this.$set(
              otherOptionsSet.otherOptions[priceGroupIndex],
              "options",
              priceGroupOptions
            );
          }
        }

        // Load categories for category_url field (products_by_category)
        const categoryUrlIndex = otherOptionsSet?.otherOptions?.findIndex(
          x => x.inputId === "category_url"
        );
        if (
          categoryUrlIndex >= 0 &&
          otherOptionsSet.otherOptions[categoryUrlIndex].options?.length === 0
        ) {
          const categoriesData = await getCategories();
          const categoriesArray = categoriesData?.categories || categoriesData;
          if (Array.isArray(categoriesArray)) {
            const categoryUrlOptions = categoriesArray.map(c => ({
              label: c.categoryName,
              value: c.categoryUrl,
              id: c.id
            }));
            this.$set(
              otherOptionsSet.otherOptions[categoryUrlIndex],
              "options",
              categoryUrlOptions
            );
          }
        }
      } catch (error) {
        console.error("Error loading dynamic options:", error);
        this.$toast.open({
          message: "Error loading options",
          type: "error",
          position: "top-right"
        });
      }
    }
  }
};
</script>
<style lang="scss">
.upload-modal {
  padding-top: 0 !important;

  .modal-content {
    max-width: 80% !important;
    width: 80% !important;
    height: auto !important;
    min-height: auto !important;
    max-height: 90vh !important;
    border-radius: 8px !important;
    margin: auto !important;
    overflow-y: auto !important;

    .file-uploader {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .body {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        min-height: 250px;
        .base-inputs {
          display: grid;
          grid-gap: 20px;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          #file_selector {
            width: 100%;
          }
        }
        .other-inputs {
          margin-top: 40px;
          display: grid;
          grid-gap: 20px;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          div {
            display: flex;
          }
        }
      }
      .footer {
        width: 100%;
        text-align: left;
        font-size: 12px;
      }
      h2 {
        font-weight: 700;
        font-size: 20px;
        width: 100%;
        text-align: center;
      }
      .close-modal-btn {
        position: absolute;
        top: 10px;
        right: 15px;
        background: none;
        border: none;
        font-size: 28px;
        cursor: pointer;
        color: #666;
        line-height: 1;
        &:hover {
          color: #000;
        }
      }
      .input-box {
        width: 250px;
        margin: 20px auto;
        input {
          text-align: center;
        }
      }
    }
  }
}
</style>
